var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#B8B8B8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 38C20.3746 38 17.7992 37.305 15.5187 35.9861L9.67462 38L10.8751 31.8111C8.99273 29.2304 8 26.1955 8 22.9997C8 14.7288 14.7288 8 22.9997 8C31.2712 8 38 14.7288 38 22.9997C38 31.271 31.2712 38 22.9997 38ZM15.7879 33.533L16.2399 33.816C18.2768 35.0931 20.6147 35.7681 22.9995 35.7681C30.0408 35.7681 35.7685 30.0404 35.7685 22.9997C35.7685 15.9596 30.0408 10.2319 22.9995 10.2319C15.9594 10.2319 10.2317 15.9596 10.2317 22.9997C10.2317 25.8642 11.1702 28.5784 12.9438 30.8483L13.2575 31.2493L12.601 34.6309L15.7879 33.533Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4272 17.2368C15.4272 17.2368 16.3079 15.6984 17.025 15.6105C17.7425 15.5222 18.6664 15.5222 18.9152 15.9912C19.1645 16.4598 20.2775 19.1858 20.2775 19.1858C20.2775 19.1858 20.4687 19.6546 20.1757 20.1091C19.8827 20.5631 19.2233 21.2223 19.2233 21.2223C19.2233 21.2223 18.857 21.6911 19.2233 22.1896C19.5897 22.6873 20.1579 23.6034 21.3336 24.7776C22.5072 25.9527 24.7615 26.7906 24.7615 26.7906C24.7615 26.7906 25.0842 26.8342 25.2897 26.6293C25.4942 26.4242 26.6084 25.0321 26.6084 25.0321C26.6084 25.0321 26.9658 24.5709 27.5602 24.8418C28.1534 25.1126 30.7248 26.3949 30.7248 26.3949C30.7248 26.3949 31.0256 26.5045 31.0256 26.9588C31.0256 27.4128 30.8418 28.5244 30.466 28.9C30.0901 29.2762 28.9916 30.4344 27.3401 30.4344C25.6891 30.4344 21.7571 29.0907 19.6618 26.9959C17.5665 24.9002 15.7061 22.7752 15.267 20.8418C14.8271 18.9075 14.8861 18.0335 15.4272 17.2368Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whatsApp.84e5e0174f520b5a1619a5200fe6340b.svg";
export { ForwardRef as ReactComponent };